// src/data/homeData.js

import consultationImg from "../assets/images/ayur_consultation_new.png";
import customisedImg from "../assets/images/custom_medi.png";
import garbhasamskaraImg from "../assets/images/garbha_new.png";
import swarnaprashanaImg from "../assets/images/swarna_new.png";
import panchakarmaImg from "../assets/images/servicespancha.jpg";

export const homeServices = [
  {
    title: "Ayurvedic Consultation",
    description:
      "Personalized consultation based on your constitution, symptoms, lifestyle and health goals.",
    image: consultationImg,
  },

  {
    title: "Customised Medication",
    description:
      "Ayurvedic medicines and formulations selected according to individual needs.",
    image: customisedImg,
  },

  {
    title: "Garbhasamskara",
    description:
      "Traditional Ayurvedic guidance supporting wellbeing through the journey towards parenthood.",
    image: garbhasamskaraImg,
  },

  {
    title: "Swarnaprashana",
    description:
      "A traditional Ayurvedic child wellness practice offered according to the monthly schedule.",
    image: swarnaprashanaImg,
  },

  {
    title: "Panchakarma",
    description:
      "Classical Ayurvedic therapies designed around individual health requirements.",
    image: panchakarmaImg,
  },
];


export const homeApproachItems = [
  {
    number: "01",
    title: "Personalized Care",
    description:
      "Every consultation begins by understanding the individual rather than simply treating a symptom.",
  },

  {
    number: "02",
    title: "Classical Ayurveda",
    description:
      "Our care remains grounded in the principles and practices of traditional Ayurveda.",
  },

  {
    number: "03",
    title: "Scientific Thinking",
    description:
      "Clinical experience and research inform a careful, contemporary approach to Ayurvedic practice.",
  },

  {
    number: "04",
    title: "Holistic Wellness",
    description:
      "Health is viewed as a balance of body, mind, lifestyle and the deeper goals of life.",
  },
];


export const homeRecognitionItems = [
  {
    number: "01",
    title: "MD (Ayurveda)",
    description:
      "Postgraduate specialization in Ayurveda with a focus on Rasashastra & Bhaishajya Kalpana.",
  },

  {
    number: "02",
    title: "Research & Publications",
    description:
      "Eight research articles in national and international journals.",
  },

  {
    number: "03",
    title: "Academic Participation",
    description:
      "More than 80 seminars and conferences across India.",
  },

  {
    number: "04",
    title: "National Recognition",
    description:
      "Recognized for academic and thesis work in Ayurveda.",
  },
];